import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import Retrieve from '../views/retrieve.vue'
/**
 *  懒加载
 * 下面2行代码，没有指定webpackChunkName，每个组件打包成一个js文件。
 */
// const Home = () => import(/* webpackChunkName: 'ImportFuncSSO' */ '../views/Home.vue')
// const Retrieve = () => import(/* webpackChunkName: 'ImportFuncSSO' */ '../views/retrieve.vue')

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/:key',
  //   name: 'Retrieve',
  //   component: Retrieve
  // },
  // {
  //   path: '/',
  //   name: 'Retrieve',
  //   component: Retrieve
  // }
  // {
  //   path: '/retrieve',
  //   name: 'Retrieve',
  //   component: Retrieve
  // },
  // {
  //   path: '/retrieve:key',
  //   name: 'Retrieve',
  //   component: Retrieve
  // },

  {
    path: '/:code',
    name: 'Home',
    component: Home
  },
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  {
    path: "*",
    name: "Home",
    component: Home
  }

]

const router = new VueRouter({
  mode: 'history',
  // mode: 'hash',
  routes
})

export default router
